import React, { Component } from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import {Link} from 'react-router-dom';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime'
import PropTypes from 'prop-types';
import MyButton from '../../util/MyButton';
import DeleteShout from './DeleteShout';
import ShoutDialog from './ShoutDialog';

//Mui stuff
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import { Typography } from '@material-ui/core';

import ChatIcon from '@material-ui/icons/Chat';
import LikeButton from './LikeButton';

import {connect} from 'react-redux';



const styles= {
    card:{
        position:'relative',
        display:'flex',
        marginBottom:20,
    },
    image:{
        width:200
    },
    content:{
        padding:25, 
        objectFit:'cover'
    }

};
class Shout extends Component {
    
render() {
        dayjs.extend(relativeTime)
        const {
            classes,
            shout:{
            body,
            shoutId,
            createdAt, 
            userImage,
            userHandle, 
            likeCount, 
            commentCount
    }, 
    user:{ authenticated, 
        credentials:{ handle }
    }
    
}=this.props;

 const deleteButton = authenticated && userHandle === handle ? (
 <DeleteShout shoutId={shoutId}/>
 ):null; 
return (
    <Card className ={classes.card}>
        <CardMedia 
        image = {userImage}
        title ="Profile image" className ={classes.image}
        />
        <CardContent className={classes.content}>
        <Typography variant="h5" component={Link} to={`/users/${userHandle}`} >{userHandle}</Typography> 
        {deleteButton}
        <Typography variant="body1">{body}</Typography>
        <Typography variant="body2" color="textSecondary">{dayjs(createdAt).fromNow()}</Typography>
        <LikeButton shoutId={shoutId}/>
        <span>{likeCount} Likes </span>
        <MyButton tip="comments">
            <ChatIcon color="primary"/>
        </MyButton>
        <span>{commentCount} comments </span>  

        <ShoutDialog shoutId={shoutId} userHandle={userHandle} openDialog={this.props.openDialog}/>

        </CardContent>
    </Card>
        )
    }
}
Shout.propTypes = {
    user:PropTypes.object.isRequired,
    shout:PropTypes.object.isRequired,
    classes:PropTypes.object.isRequired,
    openDialog:PropTypes.bool

}


const mapStateToProps = (state) =>({
    user:state.user
})
export default connect(mapStateToProps)(withStyles(styles)(Shout));
